module.exports = __webpack_public_path__ + "img/avatar7.3332c97c.png";